// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3XkO4","savePackageButton":"ClientWallet_savePackageButton__2TaGb"};